module.exports = __webpack_public_path__ + "static/media/title-bar.eaa2531b.jpg";